module.exports = __webpack_public_path__ + "static/media/bigticket-app.b084b689.png";